module.exports = __webpack_public_path__ + "img/teeth-22.a2a0707f.png";